import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Chart } from "chart.js";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-heater-substitution-chart",
  templateUrl: "./heater-substitution-chart.component.html",
  styleUrls: ["./heater-substitution-chart.component.css"]
})
export class HeaterSubstitutionChartComponent implements OnInit {
  @ViewChild("chartHeaterSubstitution") canvas;
  @Input() chartData;
  @Input() chartID;
  @Input() actionCategory;

  private chart: Chart;
  private options;
  private yAxes;
  private leftYAxisLabel;
  private rightYAxisLabel;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {}

  ngOnChanges() {
    // create or update chart only when data is provided
    if (this.chartData !== undefined) {
      this.updatechartDataWithTranslation();
      this.createChart();
    }
  }

  updatechartDataWithTranslation() {
    // updates the chart datasets labels with the string provided by the translate service
    this.chartData.datasets.forEach((dataset, index: number): void => {
      let translatedLabel = this.translateService.instant(
        "DATA." + dataset.label
      );
      this.chartData.datasets[index].label = translatedLabel;
    });
  }


  createChart() {
    const ctx = this.canvas.nativeElement.getContext("2d");
    this.resetChart();
    this.setupYAxes();
    this.setupOptions();
    this.chart = new Chart(ctx, {
      type: "bar",
      data: this.chartData,
      options: this.options
    });
  }

  setupYAxes() {
    this.getYAxesLabels();
    this.yAxes = [
      {
        id: "left",
        position: "left",
        type: "linear",
        scaleLabel: {
          display: true,
          labelString: this.leftYAxisLabel,
          fontColor: "black",
          fontSize: 14
        },
        ticks: {
          beginAtZero: true
        },
        stacked: true
      },
      {
        id: "right",
        position: "right",
        type: "linear",
        scaleLabel: {
          display: true,
          labelString: this.rightYAxisLabel,
          fontColor: "black",
          fontSize: 14
        },
        ticks: {
          beginAtZero: true,
          max: 100,
          setSize: 10
        },
        gridLines: {
          display: false
        }
      }
    ];
  }

  getYAxesLabels() {
    // axis label is simply the provided name in translate file
    let name;

    // count axis
    name = this.translateService.instant(
      "DASHBOARD.CHARTS." + this.chartID + ".LEFT_Y_LABEL_NAME"
    );
    this.leftYAxisLabel = name;

    // percentage axis
    name = this.translateService.instant(
      "DASHBOARD.CHARTS." + this.chartID + ".RIGHT_Y_LABEL_NAME"
    );
    this.rightYAxisLabel = name;
  }

  setupOptions() {
    this.options = {
      responsive: true,
      scales: {
        yAxes: this.yAxes
      },
      tooltips: {
        callbacks: {
          label: this.tooltipsLabelCallback
        }
      },

    };
  }

  tooltipsLabelCallback = (tooltipItem, data) => {
    let dataLabel = data.datasets[tooltipItem.datasetIndex].label + " :";
    let dataValue = tooltipItem.value;

    // add unit to ratio items
    if (data.datasets[tooltipItem.datasetIndex].physical_quantity == "ratio"){
      dataValue = Math.round(dataValue) + this.translateService.instant("UNITS.percentage.pct");
    }

    return [dataLabel + " " + dataValue];
  };


  resetChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = void 0;
    }
  }
}
